export default __webpack_public_path__ + "static/media/WallenDiaz2-1ETHM.327e8187.mp4";